export default function PoliciesRegister(){
    return(
        <>
            <ol>
                <li>本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録事項」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。</li>
                <li>当社は、当社の基準に従って、第１項に基づいて登録申請を行った登録希望者（以下「登録申請者」といいます。）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者の登録ユーザーとしての登録は、当社が本項の通知を行ったことをもって完了したものとします。</li>
                <li>前項に定める登録の完了時に、サービス利用契約が登録ユーザーと当社の間に成立し、登録ユーザーは本サービスを本規約に従い利用することができるようになります。</li>
                <li>当社は、登録申請者が、以下の各号のいずれかの事由に該当する場合は、登録及び再登録を拒否することがあり、またその理由について一切開示義務を負いません。<br/>
                    <ol>
                        <li>当社に提供した登録事項の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
                        <li>反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合</li>
                        <li>登録希望者が過去当社との契約に違反した者またはその関係者であると当社が判断した場合</li>
                        <li>第10条に定める措置を受けたことがある場合</li>
                        <li>名前は長い方が有利、すまない先生、秋月などの犯罪者、荒らしなどと関わっていると当社が判断した場合</li>
                        <li>捨てメアドなどのメインメールアドレス以外で登録していると判断した場合</li>
                        <li>その他、当社が登録を適当でないと判断した場合</li>
                    </ol>
                </li>
            </ol>
        </>
    )
}

export function PoliciesRegisterUser(){
    return(
        <p>登録ユーザーは、登録事項に変更があった場合、当社の定める方法により当該変更事項を遅滞なく当社に通知するものとします。</p>
    )
}

export function PoliciesPasswordAdminer(){
    return(
        <ol>
            <li>登録ユーザーは、自己の責任において、本サービスに関するパスワード及びユーザーIDを適切に管理及び保管するものとします。</li>
            <li>パスワードまたはユーザーIDの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は登録ユーザーが負うものとし、当社は一切の責任を負いません。</li>
        </ol>
    )
}